import React from "react";
import useWindowDimensions from "../../HOCs/useWindowDimensions";
import {
  academicTestimonialsCardData as academicCard,
  academicTestimonialsText as academicText,
  organizationsTestimonialsCardData as organizationsCard,
  organizationsTestimonialsText as organizationsText,
  individualsTestimonialsCardData as individualsCard,
  individualsTestimonialsText as individualsText,
} from "../data";

const TestimonialsDataController = (name) => {
  let dataCard = undefined;
  let dataText = undefined;

  // Printed page data control
  if (name === "academic") {
    dataCard = academicCard;
    dataText = academicText;
  } else if (name === "organizations") {
    dataCard = organizationsCard;
    dataText = organizationsText;
  } else if (name === "individuals") {
    dataCard = individualsCard;
    dataText = individualsText;
  }

  // Controls testimonials array
  const [minSm, setMinSm] = React.useState(0);
  const [maxSm, setMaxSm] = React.useState(1);
  const [min, setMin] = React.useState(0);
  const [max, setMax] = React.useState(3);
  const { width } = useWindowDimensions();

  const length = dataCard.length;
  const SM_BREAKPOINT = 600;
  const next = () => {
    if (width > SM_BREAKPOINT) {
      if (max >= length) return null;
      setMin(min + 3);
      setMax(max + 3);
    } else {
      if (maxSm >= length) return null;
      setMinSm(minSm + 1);
      setMaxSm(maxSm + 1);
    }
  };

  const prev = () => {
    if (width > SM_BREAKPOINT) {
      if (min === 0) return null;
      setMin(min - 3);
      setMax(max - 3);
    } else {
      if (minSm === 0) return null;
      setMinSm(minSm - 1);
      setMaxSm(maxSm - 1);
    }
  };

  return {
    dataBigScreen: dataCard.slice(min, max),
    dataSmallScreen: dataCard.slice(minSm, maxSm),
    dataCard: dataCard,
    dataText: dataText,
    next: next,
    prev: prev,
    width: width,
  };
};

export default TestimonialsDataController;
